<template>
	<inertia-head title="Ecom Bonus Webinar" />
	<div class="bg-primary">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">eCom Bonus Webinar</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Learn how to sell online. Exclusive bonus for all TRC Gold Members
					</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content mt-5">
		<div v-if="$page.props.user.current_rank === 'SILVER'">
			<div class="alert alert-warning">
				<p class="mb-0 fw-semibold">
					UPGRADE TO GOLD or HIGHER to get this exclusive bonus.
				</p>
			</div>
		</div>
		<div v-else class="block block-rounded">
			<div v-if="videos.length > 0" class="block-content block-content-full">
				<div class="row g-sm">
					<div
						v-for="video in videos"
						:key="video.id"
						class="col-md-6 mb-4 m-auto"
					>
						<h3 class="block-title mb-4">{{ video.title }}</h3>
						<div style="padding: 56.25% 0 0 0; position: relative">
							<iframe
								:src="`https://player.vimeo.com/video/${video.video_id}`"
								style="
									position: absolute;
									top: 0;
									left: 0;
									width: 100%;
									height: 100%;
								"
								frameborder="0"
								allow="autoplay; fullscreen; picture-in-picture"
								allowfullscreen
							></iframe>
						</div>
					</div>
				</div>
			</div>
			<div class="block-content block-content-full border-top text-center">
				<h5 class="fs-5 fw-normal">Want to learn more about eCommerce?</h5>
				<a
					href="https://trcacademy.ph/courses/detail/607610f90a527d5b041d7a2f"
					target="_blank"
					class="btn btn-alt-primary"
				>
					Click here to learn
				</a>
			</div>
		</div>
	</div>
</template>

<script>
import { onMounted } from 'vue'
import AuthLayout from '../../../Layouts/AuthLayout'

export default {
	layout: AuthLayout,
	props: {
		featured: Object,
		videos: Object,
	},
	setup() {
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})
	},
}
</script>
